import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/public/LoginPage.jsx";
import ForgotPasswordRoutes from "./ForgotPasswordRoutes.jsx";
import SignupPage from "../pages/public/SignupPage.jsx";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forgot-password/*" element={<ForgotPasswordRoutes />} />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
};

export default PublicRoutes;
